module.exports = __webpack_public_path__ + "img/pro7.946ca5cb.png";